//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import makeDebug from 'debug'
import { isDobFieldValid } from '@/scripts/libs/cms-registration-modules'
import {
  mapDateOfBirthConfiguration,
  YEAR,
  MONTH,
  DAY,
} from '@/elements/cms-registration-form/date-of-birth-configuration'
import wcs from '@/scripts/libs/wcs'
import { WcsNewsletter } from '@/scripts/libs/wcs/newsletter'
import RbCustomSelect from '@/elements/forms/rb-custom-select.vue'
const { storeId } = wcs.getStoreConfig()
const debug = makeDebug('newsletter-modal-success:form')
const defaultValidationErrorValue = -1
export default {
  name: 'rb-newsletter-modal-content-success-form',
  components: {
    RbCustomSelect,
  },
  props: {
    signUpEmail: String,
  },
  data() {
    return {
      YEAR,
      MONTH,
      DAY,
      gender: '',
      cutoffAge: 16,
      selectedDay: defaultValidationErrorValue,
      selectedMonth: defaultValidationErrorValue,
      selectedYear: defaultValidationErrorValue,
      validationGroup: false,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    dateOfBirthConfiguration() {
      return mapDateOfBirthConfiguration(storeId)
    },
    isDobAboveCutoffAge() {
      if (
        this.selectedDay === defaultValidationErrorValue ||
        this.selectedMonth === defaultValidationErrorValue ||
        this.selectedYear === defaultValidationErrorValue
      ) {
        return true
      }
      const age = this.calculateAgeUsingDate(
        this.selectedMonth,
        this.selectedDay,
        this.selectedYear
      )
      debug(age, this.cutoffAge)
      return age < this.cutoffAge ? false : true
    },
    yearsList() {
      const d = new Date()
      const minUserYears = d.getFullYear() - this.cutoffAge
      const yearsList = []
      for (let k = 1900; k <= minUserYears; k++) {
        yearsList.push(k)
      }
      return yearsList
    },
    monthsList() {
      const months = 12
      const monthsList = []
      const lang = document.getElementsByTagName('html')[0].lang
      for (let i = 0; i < months; i++) {
        const date = new Date(2009, i, 10)
        monthsList.push(i + 1 + '-' + date.toLocaleString(lang, { month: 'long' }))
      }
      return monthsList
    },
    daysList() {
      const dayList = []
      for (let day = 1; day <= 31; day++) {
        dayList.push(day)
      }
      return dayList
    },
    isGenericAlert() {
      if (
        this.selectedDay != defaultValidationErrorValue &&
        this.selectedMonth != defaultValidationErrorValue &&
        this.selectedYear != defaultValidationErrorValue
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    calculateAgeUsingDate(birthMonth, birthDay, birthYear) {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const day = today.getDate()
      let age = year - birthYear

      if (month < birthMonth - 1) {
        age--
      }
      if (birthMonth - 1 === month && day < birthDay) {
        age--
      }
      return age
    },
    emitCloseNewsletterModal() {
      this.$emit('closeNewsletterModal')
    },
    getMonth(value) {
      const monthValue = this.monthsList.indexOf(value)
      return monthValue + 1
    },
    onContinueToRaybanClick() {
      this.emitCloseNewsletterModal()
    },
    async onSaveClick() {
      const gender = this.gender ? this.gender : undefined
      let birthday = undefined
      if (this.yearOfBirth && this.monthOfBirth && this.dayOfBirth) {
        birthday = `${this.yearOfBirth}/${this.monthOfBirth}/${this.dayOfBirth}`
      }
      await WcsNewsletter.submitNewsletterRegistration(this.signUpEmail, gender, birthday)
      this.emitCloseNewsletterModal()
    },

    onSelectedValue(value, id) {
      switch (id) {
        case 'dayOfBirth':
          this.selectedDay = value
          break
        case 'monthOfBirth':
          this.selectedMonth = this.getMonth(value)
          break
        case 'yearOfBirth':
          this.selectedYear = value
          break
      }
      this.validateDateOfBirth()
    },

    validateDateOfBirth() {
      if (
        this.selectedDay != defaultValidationErrorValue &&
        this.selectedMonth != defaultValidationErrorValue &&
        this.selectedYear != defaultValidationErrorValue
      ) {
        this.validationGroup = this.isDobAboveCutoffAge
        return this.isDobAboveCutoffAge
      }
    },
  },
  validations() {
    return {
      gender: {},
      monthOfBirth: {
        isDobFieldValid,
      },
      dayOfBirth: {
        isDobFieldValid,
      },
      yearOfBirth: {
        isDobFieldValid,
      },
      validationGroup: ['monthOfBirth', 'dayOfBirth', 'yearOfBirth'],
    }
  },
}
